/**
 * Підписи полів цінової пропозиції — дослівно з легасі (`uk.json`, `SPEC-024`
 * §8.3). Одне джерело для ресурсів, колонок блоку й форми.
 */
export const OFFER_FIELD_LABELS = {
    blockTitle: 'Цінові пропозиції',
    cardTitle: 'Цінова пропозиція',
    offeredPrice: 'Запропонована ціна',
    offeredPriceCurrency: 'Валюта',
    comment: 'Коментар',
    responsible: 'Автор пропозиції',
    carrier: 'Перевізник',
    files: 'Файли',
    createdAt: 'Дата створення',
    updatedAt: 'Дата оновлення',
} as const
